import boundary from './settings-boundary-zh'
import workflow from './settings-workflow-zh'

/** 设置 -> 规划（计划 E）。`title` 与 `subtitle` 为计划 A 的文本，保持不变。 */
export default {
  title: '规划设置',
  subtitle: '规划模块的配置将显示在此处。',
  description: '规划模块的规划类型、坐标系、官员组、地图登记册和上传限制。',
  profiles: '规划类型',
  profilesHint: '官员只能选择已启用的规划类型。',
  profilesRequired: '请至少启用一种规划类型。',
  defaultCrs: '默认坐标系',
  roles: '官员组',
  reviewerGroups: '审核人组',
  reviewerHint: '具有管理员或发布者角色的成员可以创建、退回和重新检查提交。',
  approverGroups: '批准人组',
  approverHint: '具有管理员或发布者角色的成员还可以批准和删除。',
  noGroups: '尚无任何组。请在 设置 → 组 中创建。',
  unknownGroup: '未知或已删除的组（{{id}}）。取消勾选即可移除。',
  loadingGroups: '正在加载组…',
  separation: '要求由不同的人批准',
  separationHint: '某一版本的批准人不能是该版本的提交人。',
  register: '地图登记服务器',
  registerHint: '存放暂存和已批准规划图层的 PostgreSQL 服务器。',
  registerManaged: '自动管理：此租户的规划图层存放在其托管数据库中。',
  registerNone: '未配置',
  registerLocked: '已锁定：此服务器上已存在提交。',
  ...boundary,
  selfRegistrationSection: '申请人账户',
  selfRegistration: '允许申请人自行注册',
  selfRegistrationHint: '顾问可在公开页面申请申请人账户。每个申请都需等待批准，只有获批时才占用席位。',
  selfRegistrationLink: '公开注册页面',
  selfRegistrationLinkHint: '请将此链接分享给顾问。保存此设置后即可接受申请。',
  selfRegistrationCopy: '复制链接',
  selfRegistrationCopied: '已复制',
  allowApproverProvisioning: '允许批准人官员批准注册',
  allowApproverProvisioningHint: '否则只有租户管理员可以批准申请人注册。仅担任审核人的官员在任何情况下都不能批准。',
  allowApproverProvisioningWarning: '每次批准都会占用一个付费的查看者席位。开启后，批准人官员无需管理员即可使用席位。',
  maxUpload: '最大上传大小（MB）',
  maxUploadHint: '1 至 200 MB 之间。',
  maxUploadInvalid: '请输入 1 至 200 之间的整数。',
  save: '保存',
  saving: '正在保存…',
  saved: '设置已保存。',
  workflow,
} as const
